export default __webpack_public_path__ + "static/media/dot_red.9e89d358.jpg";